/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Product listings - Update product-grid-item on variant change

    document.querySelectorAll('.product-grid-item__variant').forEach((variant) => {
      variant.addEventListener("change", function () {
        if (this.checked) {
          const form = this.closest('form'); // Scope to this form only
          const productSelectInput = form.querySelector('input[data-product-select]');
          const addToCartButton = form.querySelector('.product__submit__add');
          const addToCartPrice = form.querySelector('.product__submit__add .priceRange');
          const addToCartText = form.querySelector('[data-add-to-cart-text]');
          if (productSelectInput) {
            const variantID = this.getAttribute("data-variant-id");
            const variantPrice = this.getAttribute("data-variant-price");
            const variantSoldOut = this.getAttribute("data-variant-sold-out");
            console.log('variantID: ', variantID, 'variantPrice', variantPrice);
            productSelectInput.value = variantID;
            addToCartPrice.innerHTML = variantPrice;
            if (variantSoldOut == 'true') {
              addToCartButton.disabled = true;
              for (let node of addToCartText.childNodes) {
              if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = 'Sold Out';
                break;
              }
            }
          } else {
              addToCartButton.disabled = false;
              for (let node of addToCartText.childNodes) {
              if (node.nodeType === Node.TEXT_NODE) {
                node.textContent = 'Add to Cart';
                break;
              }
            }
          }
        }
        }
      });
    });

  // Product info - Customize Shopify Subscription widget
  const oneTimeGroup = document.querySelector('.product__subs__group:not(:last-child)');
  const subscriptionGroup = document.querySelector('.product__subs__group:has(.product__subs__plans)');
  
  if (subscriptionGroup) {
    subscriptionGroup.innerHTML = subscriptionGroup.innerHTML + '<div class="product__subs__info"><strong>Skip or cancel anytime</div>'
  }

  // Collection - select filter
  const selectFilter = document.querySelector('.filters__select'); 
    if (selectFilter) {
       selectFilter.addEventListener('change', function() {
        const selectedType = this.value;
        if (selectedType) {
          // Redirect to a collection or search page using product type as a filter
          window.location.href = `${selectedType}`;
        }
      });
    }

  // Custom content - Toggle tab content on section custom-content
  const tabs = document.querySelectorAll('[data-tab]');
  const contents = document.querySelectorAll('[data-tab-content]');

  if (tabs) {
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-tab');
  
        // Remove 'selected' from all content areas
        contents.forEach(content => {
          content.classList.remove('selected');
        });
  
        // Add 'selected' to the matching content
        const targetContent = document.querySelector(`[data-tab-content="${target}"]`);
        if (targetContent) {
          targetContent.classList.add('selected');
        }
  
        // Optionally, you can toggle 'selected' class on the tabs too:
        tabs.forEach(t => t.classList.remove('selected'));
        tab.classList.add('selected');
      });
    });
  }


  document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('a[target="_blank"]');
    links.forEach(link => {
      link.removeAttribute('target');
    });
  });

  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
